import { render } from "./PricePredictionView.vue?vue&type=template&id=328fe5a2&scoped=true"
import script from "./PricePredictionView.vue?vue&type=script&lang=js"
export * from "./PricePredictionView.vue?vue&type=script&lang=js"

import "./PricePredictionView.vue?vue&type=style&index=0&id=328fe5a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328fe5a2"]])

export default __exports__